import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { Add as AddIcon, FileDownload as ExportIcon } from '@mui/icons-material';
import ExportButton from '../ExportButton';

const SalesHeader = ({
  exportData,
  exportColumns,
  onNewInvoice
}) => {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 0.5 }}>
      <Box>
        <Typography variant="h5" component="h1" fontWeight="bold">
          Sales
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>
          Manage your sales and invoices
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', gap: 0.5 }}>
        <ExportButton
          data={exportData}
          columns={exportColumns}
          filename="sales_invoices"
          buttonProps={{
            variant: "outlined",
            startIcon: <ExportIcon />,
            size: "small",
            sx: {
              borderRadius: '4px',
              textTransform: 'none',
              py: 0.5,
              px: 1,
            }
          }}
        />
        <Button
          variant="contained"
          color="primary"
          startIcon={<AddIcon />}
          size="small"
          onClick={onNewInvoice}
          sx={{
            borderRadius: '4px',
            textTransform: 'none',
            py: 0.5,
            px: 1,
          }}
        >
          New Invoice
        </Button>
      </Box>
    </Box>
  );
};

export default React.memo(SalesHeader); 